module.exports = __webpack_public_path__ + "static/media/WorkSans_Medium.e1d3679e.woff2";